import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import Title from "./Title";
import { globalStyles } from "../../views/Resume";

const styles = StyleSheet.create({
  summary: {
    fontSize: 6,
    fontFamily: "Lato",
  },
  bold: {
    fontFamily: "Lato Bold",
  },
});

const ProfessionalSummary = ({ professionalSummary }) => (
  <View style={globalStyles.container}>
    <View>
      <Title>Professional Summary</Title>
    </View>
    <Text style={styles.summary}>{professionalSummary}</Text>
  </View>
);

export default ProfessionalSummary;
